<div
    provideParentForm
    class="full-modal-config__form-control-row"
    *ngIf="editable?.config"
>
    <div class="full-modal-config__form-control">
        <avi-fieldset [hideContent]="!editable.config.use_split_proxy">
            <avi-fieldset_header>
                <avi-checkbox
                    [noMarginTop]="true"
                    id="use-split-proxy"
                    name="use_split_proxy"
                    fieldName="use_split_proxy"
                    objectType="{{ objectType }}"
                    [(ngModel)]="editable.config.use_split_proxy"
                >
                    {{ l10nKeys.systemProxyLabel | vtranslate }}
                </avi-checkbox>
            </avi-fieldset_header>
            <avi-fieldset_content>
                <ng-container *ngIf="editable.config.use_split_proxy">
                    <split-proxy-configuration [editable]="editable.config.split_proxy_configuration"></split-proxy-configuration>
                </ng-container>
            </avi-fieldset_content>
        </avi-fieldset>
    </div>
</div>
